import script from "./LabeledInputContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabeledInputContainer.vue?vue&type=script&setup=true&lang=ts"

import "./LabeledInputContainer.vue?vue&type=style&index=0&id=fac954e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fac954e4"]])

export default __exports__